let isOnLoad = false;
const loadedCallback = [];

export const loadSource = () => {
  const scriptNode = document.createElement("script");
  scriptNode.src =
    "https://s3plus-noq.meituan.net/v1/mss_9d9e5b6deadb43adac208535b2d92427/files/katex.min.js";
  scriptNode.onload = () => loadedCallback.forEach((fn) => fn());
  document.body.appendChild(scriptNode);
  const linkTag = `
      <link rel="stylesheet" href="https://s3plus-noq.meituan.net/v1/mss_9d9e5b6deadb43adac208535b2d92427/files/katex.min.css" />
      `;
  const div = document.createElement("div");
  div.innerHTML = linkTag;
  Array.from(div.children).forEach((node) => {
    document.body.appendChild(node);
  });
};

export function renderLatex(content, newNode) {
  if (!(window as any).katex) {
    const cb = () => {
      (window as any).katex.render(content, newNode, {
        displayMode: true,
        throwOnError: false,
        errorColor: "#cc0000",
        strict: "warn",
        macros: { "\\f": "f(#1)" },
      });
    };
    loadedCallback.push(cb);
    if (!isOnLoad) {
      isOnLoad = true;
      loadSource();
    }
  } else {
    (window as any).katex.render(content, newNode, {
      displayMode: true,
      throwOnError: false,
      errorColor: "#cc0000",
      strict: "warn",
      macros: { "\\f": "f(#1)" },
    });
  }
}

export function renderLatexToString(content: string) {
  (window as any).katex.renderToString(content, {
    displayMode: true,
    throwOnError: true,
    strict: "warn",
    macros: { "\\f": "f(#1)" },
  });
}
